'use strict';
'use es6';

// SEND

Object.defineProperty(exports, "__esModule", {
  value: true
});
var IFRAME_RESIZE = exports.IFRAME_RESIZE = 'iframe-resize';

var OPEN_CHANGE = exports.OPEN_CHANGE = 'open-change';

var CLOSED_WELCOME_MESSAGE = exports.CLOSED_WELCOME_MESSAGE = 'closed-welcome-message';

var REQUEST_WIDGET = exports.REQUEST_WIDGET = 'request-widget';

var REQUEST_HUBSPOT_UTK = exports.REQUEST_HUBSPOT_UTK = 'request-hubspot-utk';

var STORE_MESSAGES_COOKIE = exports.STORE_MESSAGES_COOKIE = 'store-messages-cookie';

var SHOW_PAGE_TITLE_NOTIFICATION = exports.SHOW_PAGE_TITLE_NOTIFICATION = 'show-page-title-notification';

var CLEAR_PAGE_TITLE_NOTIFICATION = exports.CLEAR_PAGE_TITLE_NOTIFICATION = 'clear-page-title-notification';

var START_TRACK_SCROLL_PERCENTAGE = exports.START_TRACK_SCROLL_PERCENTAGE = 'start-track-scroll-percentage';

var STOP_TRACK_SCROLL_PERCENTAGE = exports.STOP_TRACK_SCROLL_PERCENTAGE = 'stop-track-scroll-percentage';

var START_TRACK_EXIT_INTENT = exports.START_TRACK_EXIT_INTENT = 'start-track-exit-intent';

var STOP_TRACK_EXIT_INTENT = exports.STOP_TRACK_EXIT_INTENT = 'stop-track-exit-intent';

// RECEIVE

var WIDGET_DATA = exports.WIDGET_DATA = 'widget-data';

var HUBSPOT_UTK = exports.HUBSPOT_UTK = 'hubspot-utk';

var REFRESH_WIDGET_DATA = exports.REFRESH_WIDGET_DATA = 'refresh-widget-data';

var REQUEST_OPEN = exports.REQUEST_OPEN = 'request-open';

var REQUEST_CLOSE = exports.REQUEST_CLOSE = 'request-close';

var BROWSER_WINDOW_RESIZE = exports.BROWSER_WINDOW_RESIZE = 'browser-window-resize';

var SCROLL_PERCENTAGE_CHANGE = exports.SCROLL_PERCENTAGE_CHANGE = 'scroll-percentage-change';

var EXIT_INTENT = exports.EXIT_INTENT = 'exit-intent';

var PERF_ATTRIBUTES = exports.PERF_ATTRIBUTES = 'perf-attributes';